import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getMe, login, logout, homePathForRole, postAuthPath, type AuthUser } from '@/lib/auth'

export function useAuth() {
  const { data: user, isLoading } = useQuery<AuthUser | null>({
    queryKey: ['auth', 'me'],
    queryFn: getMe,
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
  return { user: user ?? null, isLoading }
}

export function useLogin() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      identifier,
      password,
      rememberMe,
    }: {
      identifier: string
      password: string
      rememberMe?: boolean
    }) => login(identifier, password, rememberMe),
    onSuccess: (data) => {
      // Drop anything cached for whoever was signed in before on this browser
      queryClient.clear()
      queryClient.setQueryData(['auth', 'me'], data.user)
    },
  })
}

export function useLogout() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: logout,
    // Clear even if the session had already expired (logout then returns 401)
    onSettled: () => queryClient.clear(),
  })
}

export { homePathForRole, postAuthPath }
